import axios from 'axios';
import { ActivityActions } from './activity.action';
import { getServerCore, defaultSnackbarTimeout } from '../../../../utils';
import { showSuccessSnackbar } from '../../Snackbar/snackbar.action';

const { serverUrls } = getServerCore();
const authUrl = serverUrls.getAuthUrl();

export const fetchUserActivityAsync = () => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch(ActivityActions.fetchActivitystart());
            const { data } = await axios({
                method: "GET",
                url: `${authUrl}/getAllActivities/${_id}`,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (data.responseCode === 200) {
                dispatch(ActivityActions.fetchActivitySuccess(data.responseData.data));
                // return dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            }
            return dispatch(ActivityActions.fetchActivityFail());
        } catch (error) {
            dispatch(ActivityActions.fetchActivityFail());
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const deleteSingleUserActivity = (activityId) => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch(ActivityActions.singleActivityDeleteStart());
            const { data } = await axios({
                method: "DELETE",
                url: `${authUrl}/removeActivity/${_id}/${activityId}`,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (data.responseCode === 200) {
                dispatch(ActivityActions.singleActivityDeleteSuccess(data.responseData));
                return dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            }
            return dispatch(ActivityActions.singleActivityDeleteFail());
        } catch (error) {
            dispatch(ActivityActions.singleActivityDeleteFail());
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}

export const deleteMultipleUserActivity = () => {
    return async (dispatch, getState) => {
        try {
            let { _id } = getState().auth.user;
            dispatch(ActivityActions.multipleActivityDeleteStart());
            const { data } = await axios({
                method: "DELETE",
                url: `${authUrl}/removeAllActivities/${_id}`,
                headers: {
                    'Content-Type': "application/json"
                }
            });
            if (data.responseCode === 200) {
                dispatch(ActivityActions.multipleActivityDeleteSuccess(data.responseData));
                return dispatch(showSuccessSnackbar('success', data.responseMessage, defaultSnackbarTimeout));
            }
            return dispatch(ActivityActions.multipleActivityDeleteFail());
        } catch (error) {
            dispatch(ActivityActions.multipleActivityDeleteFail());
            dispatch(showSuccessSnackbar('error', error.message, defaultSnackbarTimeout));
        }
    }
}